import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../../utils/auth';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'

const HelpandSupport = () => {
  const [user, setUser] = useState("");
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    issueSubject: '',
  });
  const [previousQueries, setPreviousQueries] = useState([]);
  const { t, i18n } = useTranslation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/query`,
        {
          name: formData.name,
          email: formData.email,
          phone: `+${formData.phone}`, 
          issueSubject: formData.issueSubject
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: '*/*'
          }
        }
      );
      setFormData({
        name: '',
        email: '',
        phone: '',
        issueSubject: '',
      })
      fetchUserData();
      fetchPreviousQueries();
      toast.success(response?.data?.message || "Form submitted successfully")
    } catch (error) {
      toast.error(error?.response?.data?.message || "FFailed to submit form")
      console.error("Failed to submit form:", error);
    }
  };

  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { firstName, lastName, email, mobile } = response.data.data;
      setFormData({
        name: `${firstName} ${lastName}`,
        email: email,
        phone: mobile,
        issueSubject: ''
      });
      setUser(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPreviousQueries = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/query/user/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: '*/*'
          }
        }
      );
      setPreviousQueries(response.data.data.queries);
    } catch (error) {
      console.error("Failed to fetch previous queries:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
    fetchPreviousQueries();
  }, []);

  const isFieldDisabled = (fieldValue) => {
    return fieldValue !== '';  
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t('query_loading')}</span>
        </Spinner>
      </Container>
    );
  }

  const handlePhoneChange = (phone, field) => {
  setFormData((prev) => ({
    ...prev,
    [field]: phone,
  }));
};

  return (
    <Container className='p-2'>
<Toaster position="top-right" reverseOrder={false}/>
{/* <Row> */}
        <Col lg="12">
          <Card>
            <Card.Header className="card-header d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">{t('help_and_support_title')}</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="acc-edit">
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="form-group">
                    <Form.Label>{t('name_label')}</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder={t('name_placeholder')}
                      // disabled={isFieldDisabled(formData.name)}
                    />
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label>{t('email_label')}</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder={t('email_placeholder')}
                      // disabled={isFieldDisabled(formData.email)}
                    />
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label>{t('phone_label')}</Form.Label>
                    {/* <Form.Control
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      
                      placeholder={t('phone_placeholder')}
                      // disabled={isFieldDisabled(formData.phone)}
                    /> */}
                    <PhoneInput
                                          country={(user?.country || "us").toLowerCase()} 
                                          value={formData.phone}
                                          onChange={(phone) => handlePhoneChange(phone, "phone")}
                                          inputStyle={{ width: "100%", paddingBlock:"20px" }}
                                          required
                                        />
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label>{t('issue_label')}</Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      rows={4}
                      name="issueSubject"
                      value={formData.issueSubject}
                      onChange={handleChange}
                      placeholder={t('issue_placeholder')}
                    />
                  </Form.Group>
                  <Button type="submit" className="btn btn-primary mt-1">{t('submit_button')}</Button>
                </Form>
              </div>
            </Card.Body>
          </Card>
        </Col>
      {/* </Row> */}
      
      {/* <Row className="mt-4"> */}
        <Col lg="12">
          <Card>
            <Card.Header>
              <h5>{t('previous_queries_title')}</h5>
            </Card.Header>
            <Card.Body>
              <ListGroup variant="flush">
                {previousQueries?.length > 0 ? (
                  previousQueries?.map((query) => (
                    <ListGroup.Item key={query?._id}>
                      <strong>{t('query_subject_label')}:</strong> {query?.issueSubject} <br />
                      <strong>{t('query_status_label')}:</strong> {query?.solveStatus} <br />
                      <strong>{t('query_date_label')}:</strong> {new Date(query?.createdAt).toLocaleString()}
                    </ListGroup.Item>
                  ))
                ) : (
                  <p>{t('no_previous_queries')}</p>
                )}
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      {/* </Row> */}
    </Container>
  );
};

export default HelpandSupport;
